import { COLUMN_DATA_TYPE } from './../../../shared/constants/list-view/cell-type.constant';

export const POST_SEC_LIST_COLUMNS = [
  {
    human: 'College milestones',
    key: 'milestone',
    cellType: COLUMN_DATA_TYPE.SECTION_HEADER,
    cellConfig: {},
    dataType: null,
    orderBy: null,
  },
  {
    human: 'Status',
    key: 'status',
    cellType: COLUMN_DATA_TYPE.FORMATTED_DATA,
    cellConfig: { formatType: 'status' },
    dataType: null,
    orderBy: null,
  },
  {
    human: 'Due by',
    key: 'dueBy',
    cellType: COLUMN_DATA_TYPE.FORMATTED_DATA,
    cellConfig: { formatType: 'dueBy' },
    dataType: null,
    orderBy: null,
  },
];
